import { Injectable, ɵConsole } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  CanActivate,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import * as _ from 'lodash';

import { environment } from '../../environments/environment';
import { AuthorizationService } from '../services/authorization.service';


@Injectable({
  providedIn: 'root',
})
export class FeatureGuard implements CanActivate {
  constructor(
    private router: Router,
    private authorizationService: AuthorizationService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    // Topbar is loaded and authorization service is ready
    await this.authorizationService.waitUntilReady();

    const userFeatures =
      this.authorizationService.HealthcareTopBar.currentUserDetails.Features;
    const requestedFeatureFromRoute = route.data.feature;

    const hasApplink = !!_.find(userFeatures, {
      Name: environment.applicationApplinkFeature,
      App: environment.applicationName,
    });

    // If user does not have the applink feature, redirect to no-access and return false
    if (!hasApplink) {
      this.router.navigate(['/no-access']);
      return false;
    }

    const hasRequestedFeature = !!_.find(userFeatures, {
      Name: requestedFeatureFromRoute,
      App: environment.applicationName,
    });

    //otherwise they have the feature, send them where they want to go
    if (hasRequestedFeature) {
      return true;
    }

    // If they lack the requested feature, send home
    this.router.navigate(['/']);
    return false;
  }
}
